import { useCallback } from "react";

import keyCodes from "../../constants/keyCodes";

const useSanitizedInput = defaultHandler => {
  const callback = useCallback(e => {
    const key = e.which || e.keyCode;

    switch (key) {
      case keyCodes.UP:
      case keyCodes.DOWN:
      case keyCodes.ESC:
      case keyCodes.RETURN:
        e.preventDefault();
        return;
      default:
    }

    defaultHandler(e);
  });

  return callback;
};

export default useSanitizedInput;
